import { useState } from "react";
import { LogoutResponseSchema } from "@algoquest/contracts";
import {
  apiRequest,
  ApiClientError,
  setAccessToken,
} from "../services/api/httpClient";
export function AccountRecovery({
  action,
  token,
  onClose,
}: {
  action: "forgot" | "reset-password" | "change-email";
  token?: string;
  onClose: () => void;
}) {
  const [email, setEmail] = useState(""),
    [password, setPassword] = useState(""),
    [confirm, setConfirm] = useState(""),
    [busy, setBusy] = useState(false),
    [message, setMessage] = useState(""),
    [error, setError] = useState(""),
    [done, setDone] = useState(false);
  return (
    <div className="tutorial-overlay">
      <section className="tutorial-panel">
        <h2>
          {action === "forgot"
            ? "Reset your password"
            : action === "change-email"
              ? "Confirm new email"
              : "Choose a new password"}
        </h2>
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            if (action === "reset-password" && password !== confirm) {
              setError("Passwords do not match.");
              return;
            }
            setBusy(true);
            setError("");
            try {
              await apiRequest(
                `/auth/${action === "forgot" ? "forgot-password" : action === "change-email" ? "confirm-email" : "reset-password"}`,
                {
                  method: "POST",
                  body:
                    action === "forgot"
                      ? { email }
                      : action === "change-email"
                        ? { token }
                        : { token, newPassword: password },
                },
                LogoutResponseSchema,
              );
              setMessage(
                action === "forgot"
                  ? "If this address has an account, a reset link will be sent. Check your inbox."
                  : "Account updated. Sign in again with your new credentials.",
              );
              if (action !== "forgot") setAccessToken(null);
              setDone(true);
            } catch (error) {
              setError(
                error instanceof ApiClientError
                  ? error.message
                  : "Could not complete the request. Check your connection and retry.",
              );
            } finally {
              setBusy(false);
            }
          }}
        >
          {!done && action === "forgot" && (
            <label>
              Email
              <input
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={busy}
              />
            </label>
          )}
          {!done && action === "reset-password" && (
            <>
              <label>
                New password
                <input
                  type="password"
                  autoComplete="new-password"
                  required
                  minLength={10}
                  maxLength={200}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={busy}
                />
              </label>
              <label>
                Confirm password
                <input
                  type="password"
                  autoComplete="new-password"
                  required
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  disabled={busy}
                />
              </label>
            </>
          )}
          {!done && (
            <button disabled={busy}>
              {busy
                ? "Please wait…"
                : action === "forgot"
                  ? "Send reset link"
                  : action === "change-email"
                    ? "Confirm email change"
                    : "Save new password"}
            </button>
          )}
        </form>
        {message && <p role="status">{message}</p>}
        {error && <p role="alert">{error}</p>}
        <button disabled={busy} onClick={onClose} className="w-full mt-6">
          Back to sign in
        </button>
      </section>
    </div>
  );
}
